import { borderRadius, spacing, getSkeletonColors } from '@offerzen/pinata-shame'
import { css } from '@emotion/css'

const styles = {
  card: css({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: spacing.medium,
    marginTop: spacing.medium,
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    paddingLeft: spacing.medium,
    paddingRight: spacing.medium,
    marginLeft: -spacing.medium,
    marginRight: -spacing.medium,
  }),
  addButton: css({
    width: 168,
    height: 35,
    borderRadius: borderRadius.small,
  }),
}

export const borderColor = theme =>
  css({
    borderColor: getSkeletonColors(theme),
  })

export default styles
